
        import 'Expander.79ceb47.css-module'
        export default {"Expander":"Expander_Expander_79ceb47"}
    